package com.sweetlime.dungeonamigo.presentation.ui.theme

import androidx.compose.ui.graphics.Color

object BrandColors {
    // Core palette
    val Ember         = Color(0xFFE84545)
    val EmberDim      = Color(0xFFC03535)
    val EmberAmber    = Color(0xFFE0833E)  // HP midpoint
    val Parchment     = Color(0xFFD4A843)
    val ParchmentDim  = Color(0xFFA07830)
    val SpellBlue     = Color(0xFF4A90D9)
    val SpellBlueDim  = Color(0xFF3A72AE)

    // Surfaces
    val Vault         = Color(0xFF0E0E18)  // screen background
    val Stone         = Color(0xFF1C1C28)  // card / sheet surfaces
    val StoneLight    = Color(0xFF252535)  // elevated: inputs, empty HP cells

    // Text
    val Ivory         = Color(0xFFF0EAD6)  // primary text, titles
    val IvoryDim      = Color(0xFFB0A898)  // subtitles, captions, placeholders
    val Slate         = Color(0xFF5A5A7A)  // borders, dividers, inactive icons
    val SlateLight    = Color(0xFF7A7A9A)  // hover borders, empty-state glyphs

    // Accents
    val Venom         = Color(0xFF6FA84A)  // poisoned condition
    val EnchantPurple = Color(0xFF9B6FD9)  // illusion / enchantment school

    // Legacy aliases (kept for API compatibility)
    val Background    = Vault
    val Surface       = Stone
    val SurfaceLight  = StoneLight
    val TextPrimary   = Ivory
    val TextSecondary = Slate
    val Error         = Color(0xFFFF4444)
    val Success       = Venom
    val HpFull        = Ember
    val HpMid         = EmberAmber
    val HpLow         = EmberDim
}
